// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/*\n  TODO: This is dirty, test if it affects pages outside where this component is rendered\n */\n.v-main {\n  transform-style: unset !important;\n}\n", ""]);
// Exports
module.exports = exports;
